<template>
    <div>
        <div class="home" ref="infoBox">
            <div ref="mainSplideBox">
                <b-container class="mb-5">
                    <splide :slides="mainSplide.photos" :options="mainSplide.options">
                        <splide-slide class="py-1 px-0" ref="splideSlide" v-for="(item, index) in mainSplide.photos"
                            :key="index">
                            <figure class="btn w-100 bg-blur p-0" style="max-height:70vh;"
                                :style="{ '--bg-url': bgMulti(heroCoverUrl(item), defaultHeroCover) }">
                                <b-link :href="item.Link" :target="item.Target" class="d-flex h-100">
                                    <!-- 用原生 <img> 更穩定接 error；若想沿用 <b-img> 也可 -->
                                    <img class="ratio-1440x452 mx-auto my-auto w-100 h-auto" :src="heroCoverUrl(item)"
                                        style="object-fit: contain;" @error="onImgError($event, defaultHeroCover)"
                                        alt="" />
                                </b-link>
                            </figure>
                        </splide-slide>
                    </splide>
                </b-container>
            </div>
        </div>


        <!-- 系列課程 -->
        <section class="box light-blue pt-0">
            <b-container>
                <div class="course-section-toolbar">
                <h3 class="title text-center font-weight-bolder text-dark mb-0">
                    {{ cards2.title }}
                </h3>
                    <b-button-group aria-label="最新課程瀏覽模式切換">
                        <b-button :pressed="courseDisplay.latest === 'grid'"
                            :variant="courseDisplay.latest === 'grid' ? 'primary' : 'outline-primary'"
                            v-b-tooltip.hover title="網格瀏覽" @click="setCourseDisplay('latest', 'grid')">
                            <b-icon-grid-3x3-gap></b-icon-grid-3x3-gap>
                        </b-button>
                        <b-button :pressed="courseDisplay.latest === 'list'"
                            :variant="courseDisplay.latest === 'list' ? 'primary' : 'outline-primary'"
                            v-b-tooltip.hover title="列表瀏覽" @click="setCourseDisplay('latest', 'list')">
                            <b-icon-list-ul></b-icon-list-ul>
                        </b-button>
                    </b-button-group>
                </div>
                <b-row class="courses grid mb-3 pt-3">
                    <template>
                        <b-col v-for="(item, index) in cards2.data" :key="index" md="4" class="mb-2">
                            <b-link @click="_go('./courseSeriesDetails?id=' + item.Id)" data-toggle="tooltip"
                                data-placement="top" :title="IsNull(item.Name)" class="w-100 h-100">
                                <figure class="bg-blur w-100 h-100 mb-0"
                                    :style="{ '--bg-url': bgMulti(seriesCoverUrl(item), defaultSeriesCover) }">
                                    <img :src="seriesCoverUrl(item)" class="rounded shadow ratio-1440x452 w-100 h-auto"
                                        style="object-fit:contain; max-width:100%;max-height:100%;" loading="lazy"
                                        decoding="async" @error="onImgError($event, defaultSeriesCover)" alt="" />
                                </figure>
                            </b-link>
                        </b-col>
                    </template>
                </b-row>
                <div class="more text-center">
                    <b-button pill variant="primary" class="px-5" @click="_go('./courseSeries')">檢視全部</b-button>
                </div>
            </b-container>
        </section>

        <!-- 最新課程 -->
        <section class="box light-blue">
            <b-container>
                <div class="course-section-toolbar">
                <h3 class="title text-center font-weight-bolder text-dark mb-0">
                    {{ cards3.title }}-
                    <div class="loading">
                        <span v-for="(i2, i1) in '熱烈招生中'" :key="i1">{{ i2 }}</span>
                    </div>
                </h3>
                    <b-button-group aria-label="精選課程瀏覽模式切換">
                        <b-button :pressed="courseDisplay.latest === 'grid'"
                            :variant="courseDisplay.latest === 'grid' ? 'primary' : 'outline-primary'"
                            v-b-tooltip.hover title="網格瀏覽" @click="setCourseDisplay('latest', 'grid')">
                            <b-icon-grid-3x3-gap></b-icon-grid-3x3-gap>
                        </b-button>
                        <b-button :pressed="courseDisplay.latest === 'list'"
                            :variant="courseDisplay.latest === 'list' ? 'primary' : 'outline-primary'"
                            v-b-tooltip.hover title="列表瀏覽" @click="setCourseDisplay('latest', 'list')">
                            <b-icon-list-ul></b-icon-list-ul>
                        </b-button>
                    </b-button-group>
                </div>

                <b-row :cols-md="courseDisplay.latest === 'grid' ? 3 : 1" align-v="stretch"
                    :class="['courses', 'home-courses', courseDisplay.latest, 'mb-3']">
                    <b-col v-for="(item, index) in cards3.data" :key="index"
                        :class="courseDisplay.latest === 'grid' ? 'p-3' : 'px-3 py-2'"
                        :style="courseDisplay.latest === 'grid' ? 'min-width: 288px;' : ''">
                        <div class="position-relative">
                        <b-link class="mainImage" @click="_go('./course?Id=' + item.Id)" style="text-decoration:none"
                            data-toggle="tooltip" data-placement="top" :title="IsNull(item.Name)">
                            <b-card img-alt="Image" img-top tag="article" class="course" no-body>
                                <figure class="figure-blur ratio-1440x452"
                                    style="object-fit:contain !important; object-position:center;"
                                    :style="{ '--bg-url': bgMulti(courseCoverUrl(item), defaultCourseCover) }">
                                    <b-button
                                        variant="light"
                                        size="sm"
                                        class="favorite-icon-button"
                                        :disabled="isFavoritePending(item)"
                                        @click.stop.prevent="toggleFavorite(item)"
                                    >
                                        <b-icon-heart-fill v-if="isFavorite(item)" variant="danger"></b-icon-heart-fill>
                                        <b-icon-heart v-else variant="danger"></b-icon-heart>
                                    </b-button>
                                    <img class="ratio-1440x452"
                                        style="height:100% !important; object-fit:contain !important; object-position:center;"
                                        loading="lazy" decoding="async" :src="courseCoverUrl(item)"
                                        @error="onImgError($event, defaultCourseCover)" alt="" />
                                </figure>

                                <b-card-body>
                                    <b-card-title title-tag="h5" class="mb-2 clamp-2">
                                        {{ IsNull(item.Name) }}
                                    </b-card-title>
                                    <small class="clamp-3"
                                        style="color:#888;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;text-overflow:ellipsis;"
                                        v-html="Re_html(item.Introduction)"></small>
                                </b-card-body>

                                <b-card-footer class="d-flex align-items-center justify-content-between">
                                    <div class="course-price-box">
                                        <span v-if="isApplyNow(item)" class="course-badge course-badge-list">報名中</span>
                                        <div class="course-price-text">
                                            <div class="course-price-original">
                                                <span class="mr-2">原價</span>
                                                <span class="price old-price">
                                                    NT${{ IsNull2(item.OrginalPrice, 0) | money(0, 2) }}
                                                </span>
                                            </div>
                                            <div class="course-price-current">
                                                <span class="number">NT${{ IsNull2(item.Price, 0) | money(0, 2) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="original_price d-flex align-items-center">
                                        <span class="text-black-50 font-weight-bolder">原價</span>
                                        <span class="price ml-2" style="text-decoration:line-through; color:#666">
                                            NT${{ IsNull2(item.OrginalPrice, 0) | money(0, 2) }}
                                        </span>
                                    </div>
                                    <span class="price">
                                        <span v-if="isApplyNow(item)" class="course-badge">報名中</span>
                                        <span class="number">NT${{ IsNull2(item.Price, 0) | money(0, 2) }}</span>
                                    </span>
                                </b-card-footer>
                            </b-card>
                        </b-link>
                        </div>
                    </b-col>
                </b-row>

                <div class="more text-center">
                    <b-button pill variant="primary" class="px-5" @click="_go('./courses?hot=true')">
                        檢視全部
                    </b-button>
                </div>
            </b-container>
        </section>

        <!-- 精選課程（同「最新課程」做法） -->
        <section style="background-color:#E2F5FF;" class="box">
            <b-container>
                <h3 class="title text-center font-weight-bolder text-dark">
                    {{ cards1.title }}-
                    <div class="loading">
                        <span v-for="(i2, i1) in '新班規劃中'" :key="i1">{{ i2 }}</span>
                    </div>
                </h3>

                <div class="course-section-toolbar-buttons">
                    <b-button-group aria-label="精選課程瀏覽模式切換">
                        <b-button :pressed="courseDisplay.featured === 'grid'"
                            :variant="courseDisplay.featured === 'grid' ? 'primary' : 'outline-primary'"
                            v-b-tooltip.hover title="網格瀏覽" @click="setCourseDisplay('featured', 'grid')">
                            <b-icon-grid-3x3-gap></b-icon-grid-3x3-gap>
                        </b-button>
                        <b-button :pressed="courseDisplay.featured === 'list'"
                            :variant="courseDisplay.featured === 'list' ? 'primary' : 'outline-primary'"
                            v-b-tooltip.hover title="列表瀏覽" @click="setCourseDisplay('featured', 'list')">
                            <b-icon-list-ul></b-icon-list-ul>
                        </b-button>
                    </b-button-group>
                </div>

                <b-row :cols-md="courseDisplay.featured === 'grid' ? 3 : 1"
                    :class="['courses', 'home-courses', courseDisplay.featured, 'mb-3']">
                    <b-col v-for="(item, index) in cards1.data" :key="index"
                        :class="courseDisplay.featured === 'grid' ? 'p-3' : 'px-3 py-2'">
                        <div class="position-relative">
                        <b-link class="mainImage" @click="_go('./course?Id=' + item.Id)" style="text-decoration:none"
                            data-toggle="tooltip" data-placement="top" :title="IsNull(item.Name)">
                            <b-card img-alt="Image" img-top tag="article" class="course" no-body>
                                <figure class="figure-blur ratio-1440x452"
                                    style="object-fit:contain !important; object-position:center;"
                                    :style="{ '--bg-url': bgMulti(courseCoverUrl(item), defaultCourseCover) }">
                                    <b-button
                                        variant="light"
                                        size="sm"
                                        class="favorite-icon-button"
                                        :disabled="isFavoritePending(item)"
                                        @click.stop.prevent="toggleFavorite(item)"
                                    >
                                        <b-icon-heart-fill v-if="isFavorite(item)" variant="danger"></b-icon-heart-fill>
                                        <b-icon-heart v-else variant="danger"></b-icon-heart>
                                    </b-button>
                                    <img class="ratio-1440x452"
                                        style="height:100% !important; object-fit:contain !important; object-position:center;"
                                        loading="lazy" decoding="async" :src="courseCoverUrl(item)"
                                        @error="onImgError($event, defaultCourseCover)" alt="" />
                                </figure>

                                <b-card-body>
                                    <b-card-title title-tag="h5" class="mb-2 clamp-2">
                                        {{ IsNull(item.Name) }}
                                    </b-card-title>
                                    <small class="clamp-3"
                                        style="color:#888;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;text-overflow:ellipsis;"
                                        v-html="Re_html(item.Introduction)"></small>
                                </b-card-body>

                                <b-card-footer class="d-flex align-items-center justify-content-between">
                                    <div class="course-price-box">
                                        <div class="course-price-text">
                                            <div class="course-price-original">
                                                <span class="mr-2">原價</span>
                                                <span class="price old-price">
                                                    NT${{ IsNull2(item.OrginalPrice, 0) | money(0, 2) }}
                                                </span>
                                            </div>
                                            <div class="course-price-current">
                                                <span class="number">NT${{ IsNull2(item.Price, 0) | money(0, 2) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="original_price d-flex align-items-center">
                                        <span class="text-black-50 font-weight-bolder">原價</span>
                                        <span class="price ml-2" style="text-decoration:line-through; color:#666">
                                            NT${{ IsNull2(item.OrginalPrice, 0) | money(0, 2) }}
                                        </span>
                                    </div>
                                    <span class="price">
                                        <span class="number">NT${{ IsNull2(item.Price, 0) | money(0, 2) }}</span>
                                    </span>
                                </b-card-footer>
                            </b-card>
                        </b-link>
                        </div>
                    </b-col>
                </b-row>

                <div class="more text-center">
                    <b-button pill variant="primary" class="px-5" @click="_go('./courses')">檢視全部</b-button>
                </div>
            </b-container>
        </section>

        <!-- 課程分類（背景圖也加 fallback） -->
        <section class="box white" ref="menuBox">
            <b-container>
                <h3 class="title text-center font-weight-bolder text-dark">課程分類</h3>
                <b-nav pills class="categories">
                    <b-nav-item class="catalog" v-for="(item, index) in CategoryList" :key="index" @click="navGo(item)">
                        <div class="icon" :style="{ backgroundImage: bgMulti(categoryCoverUrl(item)) }"></div>
                        <strong>{{ item.Name }}</strong>
                    </b-nav-item>
                </b-nav>
            </b-container>
        </section>

        <!-- 最新消息（背景圖 fallback） -->
        <section class="box white">
            <b-container>
                <h3 class="title text-center font-weight-bolder text-dark">
                    {{ news.title }}
                </h3>

                <div class="index-news pt-3">
                    <div v-for="(item, index) in news.data" :key="index"
                        :class="[index === 0 ? 'box-first' : 'box-basic']">
                        <b-link @click="_go('./NewsDetail?id=' + item.Id)">
                            <figure style="background-size:cover; background-position:center;"
                                :style="{ backgroundImage: bgMulti(newsCoverUrl(item), defaultNewsCover) }"></figure>
                            <div class="title">
                                <h6>{{ IsNull(item.Title) }}</h6>
                                <span class="text-black-50">
                                    <b-icon-clock></b-icon-clock> {{ IsNull(item.Create) | datefmt('YYYY-MM-DD') }}
                                </span>
                            </div>
                        </b-link>
                    </div>
                </div>

                <div class="more text-center">
                    <b-button @click="_go('./news')" pill variant="primary" class="px-5">檢視全部</b-button>
                </div>
            </b-container>
        </section>

        <!-- 忘記密碼 Modal -->
        <b-modal id="modal-forget" title="忘記密碼">
            <b-form-group id="old-password" label-for="AC_USERNAME">
                <template #label> <b-badge variant="danger  mt-1 mr-2">必填</b-badge>電子郵件／Email </template>
                <b-form-input id="input-1" v-model="Email" type="email" placeholder="電子郵件／Email"
                    required></b-form-input>
            </b-form-group>
            <b-row>
                <b-col>
                    <b-form-group label-for="forget-captcha">
                        <b-form-input id="forget-captcha" v-model="Captcha" type="text" placeholder="驗證碼"
                            required></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="auto">
                    <b-img :src="CaptchaImage" style="height:38px" fluid></b-img>
                </b-col>
            </b-row>
            <template #modal-footer="{ cancel }">
                <b-button size="sm" variant="danger" @click="cancel()">關閉</b-button>
                <b-button size="sm" variant="primary" :disabled="forgetCooldownSeconds > 0" @click="UserResetPassword()">{{ forgetCooldownSeconds > 0 ? `請稍候 ${forgetCooldownSeconds}s` : '寄送驗證信' }}</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import {
    apiCourseList,
    apiDictionary,
    apiDictionarySeries,
    apiGetPhoto,
    apiGetNewsList,
    apiGetCaptcha,
    apiRequestPasswordReset,
    apiNewCourseList,
} from '@/api/API.js';
import courseFavorite from '@/mixins/courseFavorite.js';

export default {
    name: 'Home',
    mixins: [courseFavorite],
    components: { Splide, SplideSlide },
    data() {
        return {
            responsiveOptions: { 0: { items: 1 }, 600: { items: 2 }, 1000: { items: 4 } },
            CategoryList: [],
            Param: this.$store.state.Param,
            AllParam: this.$store.state.AllParam,
            Email: '',
            Captcha: '',
            CaptchaImage: '',
            forgetCooldownSeconds: 0,
            mainSplide: {
                photos: [],
                options: { type: 'loop', focus: 'center', trimSpace: true, start: 0, autoplay: true },
            },
            nav: { title: '', loca: '', data: [] },
            cards1: { title: '精選課程', title2: '副標題', maxnum: 3, data: {} },
            cards2: { title: '系列課程', title2: '副標題', maxnum: 6, data: {} },
            cards3: { title: '最新課程', title2: '副標題', maxnum: 6, data: {} },
            news: { title: '最新消息', title2: '副標題', maxnum: 5, data: {} },
            temps: { photos: [], photosUrl: [] },
            courseDisplay: {
                latest: 'grid',
                featured: 'grid',
            },
            // 預設圖
            defaultHeroCover: '/asset/no-image.png',
            defaultSeriesCover: '/asset/no-image.png',
            defaultCourseCover: '/asset/no-image.png',
            defaultCategoryCover: '/asset/no-image.png',
            defaultNewsCover: '/asset/no-image.png',
        };
    },
    created() {
        this.Init();
        this.loadFavoriteProducts();
    },
    mounted() {
        this.$root.$on('bv::modal::show', this.handleModalShow);
    },
    beforeDestroy() {
        this.$root.$off('bv::modal::show', this.handleModalShow);
        if (this.forgetCooldownTimer) {
            clearInterval(this.forgetCooldownTimer);
        }
        if (this.CaptchaImage) {
            URL.revokeObjectURL(this.CaptchaImage);
        }
    },
    computed: {
        filteredHotTags() {
            return (this.hotTags || []).filter((tag) => tag && tag.Enable === true && tag.IsHot === true && tag.ShowOn === true);
        },
    },
    methods: {
        // ====== URL 產生與多重背景 ======
        withBust(url) {
            // 破快取，避免 CDN/瀏覽器殘留舊 404
            return `${url}?t=${Date.now()}`;
        },
        heroCoverUrl(item) {
            const p = encodeURIComponent(item.Path || '');
            return this.stableAssetUrl(`${this.$store.state.WebSite}files/_cover/${item.Id}/${p}`, item);
        },
        seriesCoverUrl(item) {
            const p = encodeURIComponent(item.Cover || '');
            return this.stableAssetUrl(`${this.$store.state.WebSite}files/_series/${item.Id}/${p}`, item);
        },
        courseCoverUrl(item) {
            return this.stableAssetUrl(`${this.$store.state.FilePath}files/_course/${item.Id}/cover.png`, item);
        },
        categoryCoverUrl(item) {
            return this.stableAssetUrl(`${this.$store.state.WebSite}files/_category/${item.Id}/cover.png`, item);
        },
        newsCoverUrl(item) {
            return this.stableAssetUrl(`${this.$store.state.WebSite}files/_news/${item.Id}/cover.png`, item);
        },
        stableAssetUrl(url, item) {
            const version =
                item?.UpdateTime ||
                item?.UpdateDate ||
                item?.ModifyDate ||
                item?.UpdatedAt ||
                item?.Create ||
                '';
            return version ? `${url}?v=${encodeURIComponent(version)}` : url;
        },
        bgMulti(primary, fallback) {
            // 用多層背景作備援：第一張失敗仍會看到第二張
            return `url('${primary}'), url('${fallback}')`;
        },

        // ====== 圖片 error fallback ======
        onImgError(e, fallback) {
            const img = e && e.target;
            if (!img || img.__errored) return; // 防止循環觸發
            img.__errored = true;
            img.src = fallback;
        },

        // ====== 初始化與其餘方法 ======
        isApplyNow(item) {
            if (!item) return false;
            const start = item.ApplyStart ? new Date(item.ApplyStart) : null;
            const end = item.ApplyEnd ? new Date(item.ApplyEnd) : null;
            if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) return false;
            const now = new Date();
            // include whole end day if time part missing
            const endAt = new Date(end.getTime());
            if (endAt.getHours() === 0 && endAt.getMinutes() === 0 && endAt.getSeconds() === 0) {
                endAt.setHours(23, 59, 59, 999);
            }
            return now >= start && now <= endAt;
        },
        setCourseDisplay(section, type) {
            this.courseDisplay[section] = type;
        },
        handleModalShow(bvEvent, modalId) {
            if (modalId === 'modal-forget') {
                this.loadForgetCaptcha();
            }
        },
        Init() {
            apiDictionary('class', 'category')
                .then((res) => (this.CategoryList = res.data))
                .catch(console.log);

            apiDictionarySeries('class', 'series')
                .then((res) => (this.cards2.data = res.data))
                .catch(console.log);

            apiGetPhoto({ Paging: { pageNumber: 1, pageSize: 99999 }, Search: { keywords: '' } })
                .then((res) => (this.mainSplide.photos = res.data))
                .catch(console.log);

            apiGetNewsList({ Paging: { pageNumber: 1, pageSize: 5 }, Search: { keywords: '' } })
                .then((res) => (this.news.data = res.data))
                .catch(console.log);

            apiCourseList({ Paging: { pageNumber: 1, pageSize: 3 }, Search: { new: false } })
                .then((res) => (this.cards1.data = res.data))
                .catch(console.log);

            apiNewCourseList({ Paging: { pageNumber: 1, pageSize: 6 } })
                .then((res) => (this.cards3.data = res.data))
                .catch(console.log);
        },

        loadForgetCaptcha() {
            this.Captcha = '';
            apiGetCaptcha()
                .then((res) => {
                    if (this.CaptchaImage) {
                        URL.revokeObjectURL(this.CaptchaImage);
                    }
                    this.CaptchaImage = URL.createObjectURL(res.data);
                })
                .catch(console.log);
        },

        startForgetCooldown() {
            this.forgetCooldownSeconds = 60;
            if (this.forgetCooldownTimer) {
                clearInterval(this.forgetCooldownTimer);
            }
            this.forgetCooldownTimer = setInterval(() => {
                if (this.forgetCooldownSeconds <= 1) {
                    clearInterval(this.forgetCooldownTimer);
                    this.forgetCooldownTimer = null;
                    this.forgetCooldownSeconds = 0;
                    return;
                }
                this.forgetCooldownSeconds -= 1;
            }, 1000);
        },
        UserResetPassword() {
            apiRequestPasswordReset({
                account: this.Email,
                captcha: this.Captcha,
            }).then(() => {
                this.startForgetCooldown();
                alert('若帳號存在，系統將寄送重設密碼通知信。');
                this.$bvModal.hide('modal-forget');
            }).catch((err) => {
                this.loadForgetCaptcha();
                const message =
                    err?.response?.data?.message || err?.response?.data?.error || err?.response?.data;
                if (message) {
                    return alert(message);
                }
                console.log(err);
            });
        },

        navGo(data) {
            this._go('./courses?category=' + data.Name);
        },
        goToCoursesByTag(tag) {
            if (!tag || !tag.Name) {
                return;
            }

            this.$router.push({
                name: 'courses',
                query: {
                    tag: tag.Name,
                },
            });
        },
        Re_html(val) {
            if (this.IsNull(val) === '') return '';
            return this.Str_Replace2(val, [
                { old: '\r\n', new: '<br>' },
                { old: '\n', new: '<br>' },
            ]);
        },
    },
};
</script>

<style lang="scss" scoped>
.loading {
    display: inline-block;
    color: white;
    animation-name: example;
    animation-duration: 4s;
}

.loading span {
    display: inline-block;
    margin: 0 -0.075em;
    animation: loading 0.8s infinite alternate;
    padding: 0.25rem;
    border-radius: 8px;
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.45);
    font-weight: bold;
}

.loading span:nth-child(2) {
    animation-delay: 0.2s;
}

.loading span:nth-child(3) {
    animation-delay: 0.4s;
}

.loading span:nth-child(4) {
    animation-delay: 0.6s;
}

.loading span:nth-child(5) {
    animation-delay: 0.8s;
}

.loading span:nth-child(6) {
    animation-delay: 0.1s;
}

@keyframes loading {
    0% {
        transform: scale(1);
        background-color: #fc4a1a;
    }

    100% {
        transform: scale(0.8);
        background-color: #f7b733;
    }
}

.figure-blur {
    position: relative;
    overflow: hidden;
    isolation: isolate;
}

.figure-blur::before {
    content: '';
    position: absolute;
    inset: -16px;
    left: 0;
    top: 0;
    background-image: var(--bg-url);
    /* 這裡吃多重背景 */
    background-size: cover;
    background-position: center;
    filter: blur(20px);
    z-index: 0;
}

.figure-blur>* {
    position: relative;
    z-index: 1;
}

/* 你原本已有的 ratio 類別就沿用 */
</style>

<style lang="scss" scoped>
.loading {
    display: inline-block;
    color: white;
    animation-name: example;
    animation-duration: 4s;
}

.loading span {
    display: inline-block;
    margin: 0 -0.075em;
    animation: loading 0.8s infinite alternate;
    padding: 0.25rem;
    border-radius: 8px;
    text-shadow: 0 0 4px rgba($color: #000000, $alpha: 0.45);
    font-weight: bold;
}

.loading span:nth-child(2) {
    animation-delay: 0.2s;
}

.loading span:nth-child(3) {
    animation-delay: 0.4s;
}

.loading span:nth-child(4) {
    animation-delay: 0.6s;
}

.loading span:nth-child(5) {
    animation-delay: 0.8s;
}

.loading span:nth-child(6) {
    animation-delay: 0.1s;
}

@keyframes loading {
    0% {
        transform: scale(1);
        background-color: #fc4a1a;
    }

    100% {
        transform: scale(0.8);
        background-color: #f7b733;
    }
}

.figure-blur {
    position: relative;
    overflow: hidden;
    isolation: isolate;
}

.figure-blur::before {
    content: '';
    position: absolute;
    inset: -16px;
    background-image: var(--bg-url);
    background-size: cover;
    background-position: center;
    filter: blur(20px);
    z-index: 0;
    left: 0;
    top: 0;
}

.figure-blur>* {
    position: relative;
    z-index: 1;
}

.course-section-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;

    .title {
        flex: 1;
    }
}

.course-section-toolbar-buttons {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
}

.course-price-box {
    display: none;
}

.box.light-blue.pt-0 .course-section-toolbar {
    display: block;
    margin-bottom: 0;

    .btn-group {
        display: none;
    }
}

.home-courses.list {
    .course {
        display: flex;
        flex-direction: row;
        height: auto;
        background-color: #fff;
        border-radius: 15px;
        overflow: hidden;
        border: 1px solid rgba(0, 0, 0, 0.06);
        cursor: pointer;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

        &:hover {
            border-color: #0d6efd;
            box-shadow: 0 10px 24px rgba(13, 110, 253, 0.14);
        }
    }

    .mainImage {
        display: block;
    }

    .figure-blur {
        width: 280px;
        min-width: 280px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.75rem 0;

        img {
            height: auto !important;
            max-height: 100%;
        }
    }

    .card-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-width: 0;
        padding: 1.5rem 1rem;
    }

    .card-footer {
        display: flex;
        align-items: center;
        min-width: 240px;
        justify-content: flex-end;
        padding: 1.5rem 1.75rem 1.5rem 1rem;
        border-top: 0;
        background-color: transparent;
    }

    .original_price,
    .card-footer > .price {
        display: none !important;
    }

    .course-price-box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 0.9rem;
        width: 100%;
    }

    .course-price-text {
        text-align: right;
        padding-right: 0.35rem;
    }

    .course-price-original {
        color: #666;
        margin-bottom: 0.35rem;
    }

    .old-price {
        color: #999;
        text-decoration: line-through;
    }

    .course-price-current .number {
        color: #ef3f44;
        font-size: 2rem;
        font-weight: 700;
        line-height: 1;
    }

    .course-badge-list {
        flex: 0 0 auto;
        font-size: 1.35rem;
        padding: 0.7rem 1rem;
        border-radius: 8px;
    }
}

.favorite-icon-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 3;
    border-radius: 999px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
}

@media (max-width: 767.98px) {
    .hot-tags-panel {
        flex-direction: column;
        align-items: stretch;
        padding: 1.25rem;
    }

    .hot-tags-list {
        justify-content: flex-start;
    }

    .course-section-toolbar {
        flex-direction: column;
        align-items: stretch;

        .btn-group {
            align-self: flex-end;
        }
    }

    .home-courses.list {
        .course {
            flex-direction: column;
        }

        .figure-blur {
            width: 100%;
            min-width: 0;
        }

        .card-footer {
            min-width: 0;
            padding: 1rem 1.25rem 1.25rem;
        }

        .course-price-box {
            justify-content: space-between;
        }

        .course-price-current .number {
            font-size: 1.6rem;
        }
    }
}
</style>
